<i class="menu-button {{ classes() }}" ng-click="onMenuToggleClick()" title="Options">&#x22EE;</i>
<c-menu menu-showing="showMenu" menu-items="menuItems"></c-menu>
